import React, { useState } from 'react';
import { FadeIn } from './FadeIn';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function FAQ() {
  const tabs = ['Todas', 'Compra', 'Producto', 'Uso', 'Garantía'];
  const [activeTab, setActiveTab] = useState('Todas');
  const [openIdx, setOpenIdx] = useState<number | null>(0);
  const faqs = [{
    q: '¿Cómo recibo el material?',
    a: 'El acceso es inmediato. Apenas confirmás el pago, recibís un email con el link de descarga.',
    category: 'Compra'
  }, {
    q: '¿El acceso es inmediato?',
    a: 'Sí. Apenas se acredita el pago, llegás a la pantalla de descarga y al email.',
    category: 'Compra'
  }, {
    q: '¿Sirve si atiendo consulta privada?',
    a: 'Sí, está pensado especialmente para consulta privada infantil.',
    category: 'Producto'
  }, {
    q: '¿También me sirve si trabajo con selectividad alimentaria?',
    a: 'Sí, hay un tomo completo dedicado a selectividad y un set de recursos visuales para esos casos.',
    category: 'Producto'
  }, {
    q: '¿Las láminas están listas para imprimir?',
    a: 'Sí, son PDFs en alta calidad listos para imprimir en A4.',
    category: 'Uso'
  }, {
    q: '¿Puedo usarlo en celular, compu o tablet?',
    a: 'Sí, los archivos son PDF y se ven en cualquier dispositivo.',
    category: 'Uso'
  }, {
    q: '¿Necesito experiencia previa para aprovecharlo?',
    a: 'No. Está pensado tanto para nutricionistas que recién empiezan en consulta infantil como para quienes ya tienen experiencia.',
    category: 'Producto'
  }, {
    q: '¿El pago es único o hay suscripción?',
    a: 'Es un pago único. Sin suscripción, sin renovaciones.',
    category: 'Compra'
  }, {
    q: '¿Cómo funciona la garantía de 7 días?',
    a: 'Tenés 7 días desde la compra para pedir devolución. Si no te suma, te devolvemos el 100% sin preguntas.',
    category: 'Garantía'
  }];
  const filteredFaqs = activeTab === 'Todas' ? faqs : faqs.filter(faq => faq.category === activeTab);
  return <section className="py-16 md:py-24 px-4 bg-black" data-id="element-39">
      <div className="max-w-3xl mx-auto" data-id="element-40">
        <FadeIn className="text-center mb-12" data-id="element-41">
          <span className="text-terracotta text-sm font-bold tracking-widest uppercase mb-4 block" data-id="element-42">
            Resolvemos tus dudas
          </span>
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-cream mb-6" data-id="element-43">
            Preguntas Frecuentes
          </h2>
          <p className="text-lg text-cream/70" data-id="element-44">
            Todo lo que necesitás saber antes de empezar.
          </p>
        </FadeIn>

        <FadeIn delay={0.1} className="mb-10" data-id="element-45">
          <div className="flex flex-wrap justify-center gap-2" data-id="element-46">
            {tabs.map(tab => <button key={tab} onClick={() => {
            setActiveTab(tab);
            setOpenIdx(null);
          }} className={`px-4 py-2 rounded-full text-sm font-bold transition-all ${activeTab === tab ? 'bg-terracotta text-white' : 'bg-surface text-cream/60 hover:text-cream hover:bg-surface/80 border border-sand/10'}`} data-id="element-47">
                {tab}
              </button>)}
          </div>
        </FadeIn>

        <div className="space-y-3 mb-16" data-id="element-48">
          {filteredFaqs.map((faq, idx) => <FadeIn key={idx} delay={idx * 0.05} data-id="element-49">
              <div className="bg-surface rounded-xl border border-sand/10 overflow-hidden" data-id="element-50">
                <button onClick={() => setOpenIdx(openIdx === idx ? null : idx)} className="w-full text-left px-6 py-5 flex items-center justify-between font-bold text-cream hover:bg-white/5 transition-colors" data-id="element-51">
                  <span className="pr-4" data-id="element-52">{faq.q}</span>
                  <ChevronDown className={`shrink-0 text-terracotta transition-transform duration-300 ${openIdx === idx ? 'rotate-180' : ''}`} size={20} data-id="element-53" />
                </button>
                <AnimatePresence data-id="element-54">
                  {openIdx === idx && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-55">
                      <div className="px-6 pb-5 text-cream/70 leading-relaxed" data-id="element-56">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}